import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatCodeBlockUtilityClass(slot) {
  return generateUtilityClass('MuiChatCodeBlock', slot);
}
export const chatCodeBlockClasses = generateUtilityClasses('MuiChatCodeBlock', ['root', 'header', 'languageLabel', 'copyButton', 'pre', 'code']);
const slots = {
  root: ['root'],
  header: ['header'],
  languageLabel: ['languageLabel'],
  copyButton: ['copyButton'],
  pre: ['pre'],
  code: ['code']
};
export const useChatCodeBlockUtilityClasses = classes => composeClasses(slots, getChatCodeBlockUtilityClass, classes);